const awsconfig = {
  AWS_REGION: process.env.REACT_APP_AWS_REGION,
  AWS_ACCESS_KEY_ID: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  AWS_SECRET_ACCESS_KEY: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  S3_BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME
};

export default awsconfig;